import React, { useMemo, useState, useEffect } from "react"
import { Link } from "react-router-dom"
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../components/Common/TableContainer"

//import components
// import Breadcrumbs from "../../components/Common/Breadcrumb"
import DeleteModal from "../../components/Common/DeleteModal"

import { SimpleStringValue } from "helpers/common_helper_functions"
import { SaveToast } from "components/Common/SaveToast"
import { Col, Row, UncontrolledTooltip, Card, CardBody } from "reactstrap"

import {
  getAllContentTeamMembers,
  deleteContentTeamMember,
  updateContentTeamMember,
} from "helpers/backendHelpers/contentTeam"

const ContentTeam = props => {
  document.title = "Content Team"

  const [deleteModal, setDeleteModal] = useState(false)
  const [saved, setSaved] = useState(false)
  const [loading, setLoading] = useState(false)
  const [contentTeamMembers, setContentTeamMembers] = useState([])
  const [contentTeamMember, setContentTeamMember] = useState({})
  useEffect(() => {
    fetchAllContentTeamMembers()
  }, [saved])

  const fetchAllContentTeamMembers = async () => {
    try {
      setLoading(true)
      const response = await getAllContentTeamMembers()
      let { contentTeamMembers } = response.data || {}
      contentTeamMembers = contentTeamMembers || []
      setContentTeamMembers(contentTeamMembers)
      setLoading(false)
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "There Was A Problem Fetching Content Teams"
      setContentTeamMembers([])
      setLoading(false)
      return SaveToast({ message, type: "error" })
    }
  }

  const onClickDelete = team => {
    setContentTeamMember(team)
    setDeleteModal(true)
  }

  const handleUpdateTeamMemberStatus = async (ct_id, status) => {
    if (!ct_id) {
      return SaveToast({
        message: "Please Enter Team Id",
        type: "error",
      })
    }
    try {
      const response = updateContentTeamMember(ct_id, { ct_status: status })
      const message = response?.message || "Team Status Updated Successfully"
      SaveToast({ message, type: "success" })

      setSaved(prevSaved => !prevSaved)
      return
    } catch (error) {
      const message =
        error?.message || "There Was A Problem Updating Team Status"
      return SaveToast({ message, type: "error" })
    }
  }

  const handleDeleteTeam = async () => {
    if (!contentTeamMember.ct_id) {
      return SaveToast({ message: "Invalid Team ID", type: "error" })
    }
    try {
      const response = await deleteContentTeamMember(contentTeamMember.ct_id)
      const message = response?.message || "Team Deleted Successfully"
      SaveToast({ message, type: "success" })

      setSaved(prevSaved => !prevSaved)
      setDeleteModal(false)
      return
    } catch (error) {
      const message = error?.message || "There Was A Problem Deleting Team"
      return SaveToast({ message, type: "error" })
    }
  }

  const handleAddButtonClick = () => {
    props.history.push("/content-team/add")
  }

  const columns = useMemo(
    () => [
      {
        Header: "Full Name",
        accessor: "ct_fullName",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Email",
        accessor: "ct_email",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Education",
        accessor: "ct_education",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Address",
        accessor: "ct_address",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Phone Number",
        accessor: "ct_phoneNumber",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Status",
        accessor: "ct_status",
        disableFilters: true,
        Cell: cellProps => {
          const cellData = cellProps.row.original
          return (
            <div className="form-check form-switch form-switch-md">
              <input
                type="checkbox"
                className="form-check-input"
                id={`ct_status_checkbox-${cellData.ct_id}`}
                name={`ct_status_checkbox-${cellData.ct_id}`}
                defaultChecked={cellData.ct_status}
                onChange={e => {
                  let { checked, name } = e.target
                  document.getElementById(name).checked = checked
                  return handleUpdateTeamMemberStatus(cellData.ct_id, checked)
                }}
              />
            </div>
          )
        },
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-dark"
                onClick={() => {
                  props.history.push(
                    "/content-team/view/" + cellProps.row.original.ct_id
                  )
                }}
              >
                <i className="mdi mdi-eye font-size-18" id="viewtooltip" />
                <UncontrolledTooltip placement="top" target="viewtooltip">
                  View
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  props.history.push(
                    "/content-team/edit/" + cellProps.row.original.ct_id
                  )
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Edit
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const teamData = cellProps.row.original
                  onClickDelete(teamData)
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Delete
                </UncontrolledTooltip>
              </Link>
            </div>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteTeam}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          {/* <Breadcrumbs title="Content" breadcrumbItem="Team" /> */}
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={contentTeamMembers}
                    isGlobalFilter={true}
                    isAddOptions={true}
                    addButtonLabel="Add Content Team Member"
                    handleAddButtonClick={handleAddButtonClick}
                    customPageSize={10}
                    className="custom-header-css"
                    canExportCsv={true}
                    dataFetchLoading={loading}
                    canPrint={false}
                    noDataMessage="No system activity found."
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ContentTeam
